import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import usePDFPrintHook from "../../customHooks/usePDFPrintHook";
import { useState } from "react";

const EditManifestComponent = loadable(
  () => import("../../components/Manifest/EditManifest")
);
const EditManifest = () => {
  const { id } = useParams()
  const [currentPDFBlob, setCurrentPDFBlob] = useState("")

  const { data, isLoading } = useGetHook({
    queryKey: [`Manifest-${id}`],
    url: `${APIS.MANIFEST}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`manigest-${id}`, "manigest"],
    navigateURL: "",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: attachConsignmentMutateAsync } = usePostHook({
    queryKey: ["manifest-items"],
    navigateURL: "",
  });

  const handleAttachConsignment = async (consignmentId: string) => {
    const url = `${APIS.MANIFEST_ITEMS}`;
    let formData = {
      manifest: id,
      order: consignmentId
    };
    try {
      await attachConsignmentMutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }

  const { mutateAsync: downloadManifest, isPostLoading:isPrintLoading } = usePDFPrintHook({
    queryKey: [],
  });

  const handlePrint = async () => {
    const url = `${APIS.MANIFEST}${id}/print-pdf/`;
    let formData = {
    };
    try {
      const res = await downloadManifest({url, formData});
      const fileURL = URL.createObjectURL(res?.data);
      setCurrentPDFBlob(fileURL)
      window.open(fileURL);
    } catch (err) {
      console.log(err);
    }
  }


  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Manifest</span>
      </div>
      {isLoading ? <Spinner /> : <EditManifestComponent
        isLoading={isPatchLoading}
        data={data}
        handleEdit={handleEdit}
        handleAttachConsignment={handleAttachConsignment}
        handlePrint={handlePrint}
        isPrintLoading={isPrintLoading}
      />}
    </>
  );
};
export default EditManifest;
